import { getPoMaterials } from "../api";

export const onGettingPoData = async ({ id, setSelectedPoManager }) => {
  console.log("poId", id);
  if (!id) {
    alert("Please select a specific drawing to be added.");
  } else {
    const data = await getPoMaterials(id);

    setSelectedPoManager(data);
  }
};
